<!-- Essential cookies -->
<h2 class="mb-3">{{ legalCookiesSettingsData.title }}</h2>

<div class="section info-section">
	<div>
		<!-- Heading -->
		<h5 class="d-flex justify-content-between">
			{{ legalCookiesSettingsData.essential.title }}

			<!-- Checkbox -->
			<div class="form-check form-switch">
				<input
					class="form-check-input"
					type="checkbox"
					id="essentialCookies"
					checked
					disabled
				/>
				<label
					class="form-check-label"
					for="essentialCookies"
				></label>
			</div>
		</h5>

		<!-- Text -->
		<p *ngIf="showDescriptions">{{ legalCookiesSettingsData.essential.info }}</p>
	</div>

	<!-- Functional Cookies -->
	<div>
		<!-- Heading -->
		<h5 class="d-flex justify-content-between mt-3">
			{{ legalCookiesSettingsData.functional.title }}

			<!-- Checkbox -->
			<div class="form-check form-switch">
				<input
					class="form-check-input"
					type="checkbox"
					id="functionalCookies"
					checked
					disabled
				/>
				<label
					class="form-check-label"
					for="functionalCookies"
				></label>
			</div>
		</h5>

		<!-- Text -->
		<p *ngIf="showDescriptions">{{ legalCookiesSettingsData.essential.info }}</p>
	</div>

	<!-- Social Media COokies -->
	<div>
		<!-- Heading -->
		<h5 class="d-flex justify-content-between mt-3">
			{{ legalCookiesSettingsData.socialMedia.title }}

			<!-- Checkbox -->
			<div class="form-check form-switch">
				<input
					class="form-check-input"
					type="checkbox"
					id="EnumCookieUsageInputId.SocialMediaCookies"
					[(ngModel)]="socialMediaCookies"
					(ngModelChange)="updateSocialMediaCookies()"
				/>
				<label
					class="form-check-label"
					for="EnumCookieUsageInputId.SocialMediaCookies"
				></label>
			</div>
		</h5>

		<!-- Text -->
		<p *ngIf="showDescriptions">{{ legalCookiesSettingsData.socialMedia.info }}</p>
	</div>

	<!-- Analytical Cookies -->
	<div>
		<!-- Heading -->
		<h5 class="d-flex justify-content-between mt-3">
			{{ legalCookiesSettingsData.analytical.title }}

			<!-- Checkbox -->
			<div class="form-check form-switch">
				<input
					class="form-check-input"
					type="checkbox"
					id="EnumCookieUsageInputId.AnalyticsCookies"
					[(ngModel)]="analyticsCookies"
					(ngModelChange)="updateAnalyticalCookies()"
				/>
				<label
					class="form-check-label"
					for="EnumCookieUsageInputId.AnalyticsCookies"
				></label>
			</div>
		</h5>

		<!-- Text -->
		<p *ngIf="showDescriptions">{{ legalCookiesSettingsData.analytical.info }}</p>
	</div>

	<!-- Cookies Settings Info -->
	<div *ngIf="showDescriptions">
		<!-- Heading -->
		<h5>{{ legalCookiesSettingsData.cookieSettings.title }}</h5>

		<!-- Text -->
		<p>{{ legalCookiesSettingsData.cookieSettings.info }}</p>
	</div>
</div>
